import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import Noty from 'noty';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { Modal, Form, FormGroup, FormControl } from 'react-bootstrap';
import Button from '../ui/Button';
import Loader from '../ui/Loader';

class CategoryDialog extends Component {
  constructor(props) {
    super(props);

    this.envContext = props.isThesaurus ? 'thesaurusDialog' : 'categoryDialog';
    this.state = {
      isSubmitting: false,
      name: '',
      dialogTitle: `${this.envContext}.addHeader`,
      dialogSaveButtonLabel: `${this.envContext}.createButton`,
      isDelete: false,
      newName: '',
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onDeleteCheck = this.onDeleteCheck.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isEdit !== this.props.isEdit || prevProps.editRequests !== this.props.editRequests
      || prevProps.isThesaurus !== this.props.isThesaurus ||
      prevProps.selectedCategoryData !== this.props.selectedCategoryData) {
      let isSubmitting = false;
      let name = '';
      let dialogTitle = `${this.envContext}.addHeader`;
      let dialogSaveButtonLabel = `${this.envContext}.createButton`;
      let isDelete = false;

      if (this.props.isThesaurus !== prevProps.isThesaurus) this.envContext = this.props.isThesaurus ? 'thesaurusDialog' : 'categoryDialog';
      // change default for edit existing category
      if (this.props.isEdit) {
        const existingRequest = this.props.editRequests.get(this.props.selectedCategoryData.id);
        isSubmitting = !!existingRequest;
        name = existingRequest ? existingRequest.get('categoryName') :
          this.props.selectedCategoryData.name;
        dialogTitle = `${this.envContext}.editHeader`;
        dialogSaveButtonLabel = `${this.envContext}.saveButton`;
        isDelete = false;
      } else if (this.props.selectedCategoryData) {
        // create category at non-root level
        name = this.props.selectedCategoryData.name;
        dialogTitle = `${this.envContext}.createChildHeader`;
        dialogSaveButtonLabel = `${this.envContext}.createButton`;
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSubmitting,
        name,
        dialogTitle,
        dialogSaveButtonLabel,
        isDelete,
        newName: name,
      });
    }
  }

  onDeleteCheck() {
    this.setState({ isDelete: !this.state.isDelete });
  }

  onFormSubmit(e) {
    e.preventDefault();

    if (this.state.isDelete) {
      new Noty({
        theme: 'bootstrap-v4',
        type: 'info',
        text: this.props.intl.formatMessage({ id: `${this.envContext}.deleteInProgress` }),
        layout: 'center',
        closeWith: 'click',
        timeout: 4000,
      }).show();
      this.props.onDeleteSubmit(this.props.selectedCategoryData.id);
    } else if (this.props.isEdit) {
      this.props.onEditSubmit(
        this.props.selectedCategoryData.id, this.state.newName
      );
    } else {
      this.props.onCreateSubmit(
        // parent id needs to be undefined to default to root. null won't work
        this.props.selectedCategoryData ? this.props.selectedCategoryData.id : undefined,
        this.state.newName
      );
    }

    // making the assumption that it will successfully submit so it seems speedier
    this.props.onCategoryDialogToggle(false);
  }

  render() {
    const {
      isCategoryDialogShown,
      onCategoryDialogToggle,
      intl,
      } = this.props;

    return (
      <div className="category-dialog">
        <Modal
          show={isCategoryDialogShown}
          onHide={() => onCategoryDialogToggle(false)}
          dialogClassName={classNames('category-dialog__overlay', {
            'category-dialog__overlay--edit': this.props.isEdit,
          })}
          style={{ opacity: 1 }}
        >
        <span
          onClick={() => onCategoryDialogToggle(false)}
          className="category-dialog__close-button"
        />

          <div className="category-dialog__form">
            <div className="category-dialog__form-header">
              {intl.formatMessage({ id: this.state.dialogTitle })}

              <div className="category-dialog__form-header-sub">
                {this.state.name}
              </div>
            </div>

            <Form onSubmit={this.onFormSubmit}>
              <FormGroup className="category-dialog__form-name">
                <FormControl
                  type="text"
                  disabled={this.state.isSubmitting}
                  onChange={e => this.setState({ newName: e.target.value })}
                  placeholder={intl.formatMessage({ id: `${this.envContext}.namePlaceholder` })}
                  value={this.state.newName}
                />
              </FormGroup>

              {
                this.props.isEdit ? (
                  <Form.Group>
                    <Form.Check
                      type='checkbox'
                      onClick={this.onDeleteCheck}
                      checked={this.state.isDelete}
                      label={intl.formatMessage({ id: `${this.envContext}.deleteCheckbox` })}
                    />
                  </Form.Group>
                ) : null
              }

              {
                this.state.isDelete ?
                  <Button type="submit" variant="danger">
                    { intl.formatMessage({ id: `${this.envContext}.deleteButton` })}
                  </Button>
                  :
                  <Button primary type="submit" disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? <Loader /> :
                      intl.formatMessage({ id:this.state.dialogSaveButtonLabel}) }
                  </Button>
              }
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

CategoryDialog.propTypes = {
  isCategoryDialogShown: PropTypes.bool,
  onCategoryDialogToggle: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  isEdit: PropTypes.bool,
  editRequests: PropTypes.instanceOf(Map),
  selectedCategoryData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  isThesaurus: PropTypes.bool,
};

export default injectIntl(CategoryDialog);



// WEBPACK FOOTER //
// ./src/js/components/CategoryDialog/index.jsx